import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';
import { shiftStatuses } from '~/util/types/shifts';
import { baseUserSchema } from '~/util/types/users';

export const shiftsFiltersSchema = z
    .object({
        user: baseUserSchema.nullable().default(null),
        status: z.enum(shiftStatuses).nullable().default(null),
    })
    .extend(paginatedQuerySchema().shape);

export type shiftsFiltersType = z.input<typeof shiftsFiltersSchema>;
export const defaultShiftsFilters = shiftsFiltersSchema.parse({});

export const shiftsParamsSchema = shiftsFiltersSchema.extend({
    tab: z.enum(['planning', 'all']).default('planning'),
});

export type shiftsParamsType = z.input<typeof shiftsParamsSchema>;
export const defaultShiftsParams = shiftsParamsSchema.parse({});
